import React, { useState, useEffect } from "react";
import "./Header.css";
import { FaWrench, FaPhone } from 'react-icons/fa';
import AppointmentForm from "./appointments_form";
import { PHONE_NUMBER } from './config';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isRepairModalOpen, setIsRepairModalOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const openRepairModal = (e) => {
    e.preventDefault();
    setIsRepairModalOpen(true);
    setIsMenuOpen(false);
  };

  const closeRepairModal = () => {
    setIsRepairModalOpen(false);
  };

  return (
    <>

      <header className={`header-container ${isScrolled ? "scrolled" : ""}`}>
        <div className="header-left">
          <FaWrench className="wrench-icon" />
          <img src="/images/logo-wolf.png" alt="Icon 1" className="small-icon" />
          <img src="/images/logo-subzero.png" alt="Icon 2" className="small-icon" />
          <img src="/images/logo-cove.png" alt="Icon 3" className="small-icon" />
        </div>

        <nav className="header-center">
          <a href="#about-me" className="nav-link">ABOUT US</a>
          <a href="#reviews" className="nav-link">REVIEWS</a>
          <a href="#faq" className="nav-link">FAQ</a>
          <a href="#we-repair" className="nav-link">WE REPAIR</a>
          <a href="#contact-section" className="nav-link">CONTACTS</a>
        </nav>

        <div className="header-right">
          <span className="phone-number">
            <a href="tel:7738653089" className="phone-link">
              <FaPhone className="phone-icon" /> {PHONE_NUMBER}
            </a>
          </span>
          <a href="#schedule-appointment-section" onClick={openRepairModal}>
            <button className="repair-btn">REQUEST REPAIR</button>
          </a>

          <button className={`hamburger-icon ${isMenuOpen ? "open" : ""}`} onClick={toggleMenu}>
            <span></span><span></span><span></span><span></span>
          </button>

          <div className={`side-menu ${isMenuOpen ? "open" : ""}`}>
            <span className="side-link" onClick={toggleMenu}>
            <a href={`tel:${PHONE_NUMBER}`} className="phone-link">
              <FaPhone className="side-phone-icon" /> {PHONE_NUMBER}
              </a>
            </span>
            <a href="#about-me" className="side-link" onClick={toggleMenu}>ABOUT US</a>
            <a href="#reviews" className="side-link" onClick={toggleMenu}>REVIEWS</a>
            <a href="#faq" className="side-link" onClick={toggleMenu}>FAQ</a>
            <a href="#we-repair" className="side-link" onClick={toggleMenu}>WE REPAIR</a>
            <a href="#contact-section" className="side-link" onClick={toggleMenu}>CONTACTS</a>
            <hr className="side-separator" />
            <a href="#schedule-appointment-section" onClick={openRepairModal}>
              <button className="repair-btn">REQUEST REPAIR</button>
            </a>
          </div>
        </div>

        {isRepairModalOpen && (
          <div className={`repair-modal-overlay ${isRepairModalOpen ? "open" : ""}`} onClick={closeRepairModal}>
            <div className={`repair-modal-content ${isRepairModalOpen ? "open" : ""}`} onClick={(e) => e.stopPropagation()}>
              <button className="modal-close-btn" onClick={closeRepairModal}>&times;</button>
              <AppointmentForm isModal />
            </div>
          </div>
        )}
      </header>
      <div className="mobile-title-under-header">
        <div className="title-wrapper">
          <FaWrench className="mobile-title-wrench-bg" />
          <div className="mobile-title-text">
            <div className="mobile-line-1">SUB-ZERO</div>
            <div className="mobile-line-2">REPAIR SERVICES</div>
            <div className="mobile-line-3">
              <a href={`tel:${PHONE_NUMBER}`} className="phone-link">
                <FaPhone className="phone-icon-mobile" /> {PHONE_NUMBER}
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;